import { useForm } from "react-hook-form";
import { KuchikomyuSetting } from "../../types/kuchikomyu";

export type FormData = {
  branch_score: string;
  g_url: string;
  en_url: string;
  default_url: string;
  default_en_url: string;

};

export const useEditKuchikomyuSettingFormForAdmin = (kuchikomyuSetting: KuchikomyuSetting) => {
  const methods = useForm<FormData>({
    defaultValues: {
      branch_score: kuchikomyuSetting.branch_score.toString(),
      g_url: kuchikomyuSetting.g_url,
      en_url: kuchikomyuSetting.en_url,
      default_url: kuchikomyuSetting.default_url,
      default_en_url: kuchikomyuSetting.default_en_url,
    },
    mode: "onChange",
  });

  return methods; // reset も含めてすべてのメソッドを返す
};